jQuery(document).ready(function () {
  function updateGriLinks() {
    const urlHref = window.location.href;
    const urlScroll = urlHref.split("#")[1];

    $(".gri-link").each(function () {
      let griLink = $(this).attr("id");
      if (griLink === urlScroll) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    const target = $("#" + urlScroll);
    if (target.length > 0) {
      const acordeonContent = target.parents(".accordion .collapse");
      console.log(acordeonContent);
      if (acordeonContent.length > 0 && !acordeonContent.hasClass("show")) {
        acordeonContent
          .parent(".accordion__item")
          .find(".accordion__btn")
          .click();
      }
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 100,
        },
        1200
      );
    }
    return false;
  }
  setTimeout(updateGriLinks, 700);

  window.onhashchange = updateGriLinks;
});
